import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Ad type
 */
export class AdTypeValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {String|Number} deps.category1Id
   * @param {String|Number} deps.category2Id
   * @param {String|Number} deps.category3Id
   * @param {String|Number} deps.offerTypeId
   */
}
